import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const ProductPageGrid = styled.div`
  &:after {
    content: '';
    clear: both;
    display: table;
  }
`;

export const Left = styled.div`
  ${theme.screens.Md} {
    clear: left;
    float: left;
    width: calc(100% - ${size(50)});
    padding-right: ${size(6)};
  }
`;

export const Right = styled.div`
  ${theme.screens.Md} {
    clear: right;
    float: right;
    width: ${size(50)};
  }
`;

export const LabelWrapper = styled.div`
  display: flex;

  & ~ & {
    margin-left: ${size(2)};
    ${theme.screens.LtLg} {
      margin-left: ${size(1)};
    }
  }
`;

export const GalleryFooter = styled.div`
  position: relative;
  min-height: 25px;
`;

export const GalleryFooterBrands = styled.div`
  ${theme.screens.Md} {
    margin-bottom: ${size(6)};
  }
`;

export const GalleryFooterControls = styled.div`
  ${theme.screens.LtMd} {
    overflow: hidden;
    margin-top: ${size(1)};
  }

  ${theme.screens.LtXS} {
    overflow: hidden;
    margin-top: ${size(2)};
  }
`;

export const FlagContainer = styled.div`
  position: absolute;
  z-index: 1;
  &.product-page {
    ${theme.screens.LtMd} {
      left: 0;
    }
  }
`;

export const MarkingsWrapper = styled.div`
  ${theme.screens.LtMd} {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }
`;

export const ProductListingWrapper = styled.div`
  width: 100%;
  background-color: rgb(250, 249, 248);
`;

export const TestFreaksBadge = styled.div`
#testfreaks-badge:empty {
    display: none;
  }
  .testfreaks-section-loaded {
    display: block;
    margin-bottom: 16px;
    ${theme.screens.LtMd} {
      margin-bottom: 8px;
    }
  }
`;
